import { PackageVersionEntityModel } from "src/store/models/entity/packageVersion/entity";
import { PackageVersionHelperModel } from "src/store/models/entity/packageVersion/helper";

export const encooPackageVersionModels = {
  entity: PackageVersionEntityModel,
  helper: PackageVersionHelperModel,
};
